import React from 'react';
import uniqid from 'uniqid';

import Breadcrumb from './breadcrumb/breadcrumb';

export interface BreadcrumbData {
  label: string;
  href?: string;
  isActive?: boolean;
}

interface BreadcrumbsProps {
  breadcrumbs: BreadcrumbData[];
  customClass?: string;
}

const Breadcrumbs = ({
  breadcrumbs,
  customClass = '',
}: BreadcrumbsProps): React.JSX.Element => (
  <div className={`${customClass} flex mt-4`} data-testid="breadcrumbs">
    {!!breadcrumbs.length &&
      breadcrumbs.map((breadcrumb, i) => (
        <Breadcrumb
          key={uniqid()}
          {...{
            isLast: i === breadcrumbs.length - 1,
            isFirst: i === 0,
            ...breadcrumb,
          }}
        />
      ))}
  </div>
);

export default Breadcrumbs;
